import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, SERVICES_LIST } from '../data/mockData';

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12">
          
          {/* Company Brand Column */}
          <div className="lg:col-span-4 space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src={COMPANY_INFO.logo} 
                alt="K-TO Ventilationsteknik Logo" 
                className="w-auto h-8 md:h-10 object-contain bg-white/95 rounded-lg p-1.5 shadow-sm"
              />
            </div>

            <p className="text-sm text-slate-400 leading-relaxed">
              Professionel ventilationsteknik til erhverv og industri. Med 30 års erfaring leverer vi service, indregulering, fejlfinding, reparation, salg, montering og rensning på hele Fyn og i hele Jylland.
            </p>

            <div className="pt-2 text-xs text-slate-500 space-y-1">
              <p>Juridisk navn: <strong className="text-slate-400 font-semibold">{COMPANY_INFO.legalName}</strong></p>
              <p>CVR-nr.: <strong className="text-slate-400 font-semibold">{COMPANY_INFO.cvr}</strong></p>
            </div>
          </div>

          {/* Quick Links Column */}
          <div className="lg:col-span-3 space-y-3">
            <h3 className="text-sm font-extrabold uppercase tracking-wider text-white border-b border-slate-800 pb-2">
              Genveje
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-sky-400 transition-colors duration-150 inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true"></i>
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/k-to-ventilationsteknik" className="hover:text-sky-400 transition-colors duration-150 inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true"></i>
                  <span>K-TO Ventilationsteknik</span>
                </Link>
              </li>
              <li>
                <Link to="/erhverv-og-industri" className="hover:text-sky-400 transition-colors duration-150 inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true"></i>
                  <span>Erhverv og industri</span>
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-sky-400 transition-colors duration-150 inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true"></i>
                  <span>Galleri</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-sky-400 transition-colors duration-150 inline-flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-[10px] text-sky-500" aria-hidden="true"></i>
                  <span>Kontakt</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Services Column */}
          <div className="lg:col-span-2 space-y-3">
            <h3 className="text-sm font-extrabold uppercase tracking-wider text-white border-b border-slate-800 pb-2">
              Ydelser
            </h3>
            <ul className="space-y-1.5 text-xs">
              {SERVICES_LIST.map((service) => (
                <li key={service.slug}>
                  <Link 
                    to={`/ydelser/${service.slug}`} 
                    className="hover:text-sky-400 transition-colors duration-150 line-clamp-1"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Details Column */}
          <div className="lg:col-span-3 space-y-4">
            <h3 className="text-sm font-extrabold uppercase tracking-wider text-white border-b border-slate-800 pb-2">
              Kontakt
            </h3>

            <div className="space-y-3 text-xs">
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-sky-400 mt-1" aria-hidden="true"></i>
                <div>
                  <p className="font-semibold text-white">{COMPANY_INFO.address}</p>
                  <p className="text-slate-400">{COMPANY_INFO.zipCity} - Danmark</p>
                </div>
              </div>

              <div className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-sky-400" aria-hidden="true"></i>
                <a 
                  href={`tel:${COMPANY_INFO.phoneRaw}`} 
                  className="hover:text-white font-bold text-slate-200 transition-colors nowrap-contact"
                >
                  {COMPANY_INFO.phone}
                </a>
              </div>

              {/* General Email */}
              <div className="p-2.5 rounded-lg bg-slate-900 border border-slate-800 space-y-0.5">
                <span className="block text-[10px] uppercase font-bold text-slate-400 tracking-wider">
                  Generelle henvendelser
                </span>
                <a 
                  href={`mailto:${COMPANY_INFO.email}`} 
                  className="font-bold text-sky-400 hover:text-sky-300 transition-colors block text-xs nowrap-contact"
                >
                  {COMPANY_INFO.email}
                </a>
              </div>

              {/* Invoice Email (Visually Distinguished) */}
              <div className="p-2.5 rounded-lg bg-emerald-950/40 border border-emerald-800/50 space-y-0.5">
                <span className="block text-[10px] uppercase font-bold text-emerald-400 tracking-wider">
                  Fakturaer
                </span>
                <a 
                  href={`mailto:${COMPANY_INFO.invoiceEmail}`} 
                  className="font-bold text-emerald-300 hover:text-emerald-200 transition-colors block text-xs nowrap-contact"
                >
                  {COMPANY_INFO.invoiceEmail}
                </a>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Copyright */}
        <div className="mt-12 pt-6 border-t border-slate-900 text-xs text-slate-500 flex flex-wrap justify-between items-center gap-4">
          <p>
            Copyright © {new Date().getFullYear()} K-TO Ventilationsteknik ({COMPANY_INFO.legalName}) • CVR: {COMPANY_INFO.cvr}
          </p>
          <p className="text-slate-600">
            Specialiseret ventilationsservice på Fyn og i hele Jylland
          </p>
        </div>
      </div>
    </footer>
  );
}
